import React, { Component } from 'react';
import Header from '../../Components/Header';
import {
  ContainerWindowTitle,
  Linha,
  LinhaRodape,
  DivRodape,
  Container,
  DivDetalhe,
} from './styles';
import api from '../../services/api';
import { alerta } from '../../services/funcoes';
import { getFromStorage } from '../../services/auth';
import DirectTituloJanela from '../../Components/@bit/DirectTituloJanela';
import { Icon } from 'react-materialize';
import { tratarErros } from '../../services/funcoes';

export default class BasicBook extends Component {
  state = {
    loading: false,
    listaBookbasico: [],
    bookBasicoSelecionado: {},
    listaEmpresas: [],
  };
  /*INICIALIZACAO TELA*/
  async componentDidMount() {
    this.setState({ loading: true });
    await this.carregarVariaveisEstado();
    await this.carregarListaBookBasico();
    await this.carregarEmpresas();
    this.setState({ loading: false });
  }

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();
    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
      empresaCfId: sessao.empresaCfId,
    });
  };

  carregarEmpresas = async (email) => {
    try {
      const retorno = await api.get('/v1/accounts/empresas');
      if (!retorno) {
        this.setState({ listaEmpresas: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {

          this.setState({ listaEmpresas: retorno.data.data });
        } else {
          this.setState({ listaEmpresas: [] });
        }
      }
    } catch (err) {
      // //
      alerta('Erro ao carregar as empresas =>' + err);
    }
  };

  carregarListaBookBasico = async () => {
    try {
      let url = '/v1/permissoes/bookbasico';
      const retorno = await api.get(url);
      if (!retorno) {
        this.setState({ listaBookbasico: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          if (retorno.data.data.length === 0) {
            this.setState({ listaBookbasico: [] });
          } else {
            this.setState({
              listaBookbasico: retorno.data.data,
            });
          }
        } else {
          this.setState({ listaBookbasico: [] });
        }
      }
    } catch (err) {
      alerta('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  carregarListaEmpresasPermitidas = async (book_id) => {
    try {
      let url = `/v1/permissoes/bookbasico/permitidas/${book_id}`;
      const retorno = await api.get(url);
      if (retorno) {
        if (retorno.data && retorno.data.sucess) {
          const { listaEmpresas } = this.state;
          const empresasPermitidas = retorno.data.data;
          let _listaEmpresas = [];

          listaEmpresas.forEach(async (empresa) => {
            empresa.SELECTED = false;
            empresasPermitidas.forEach(async (permitida) => {
              if (
                empresa.EMP_ID.toString() === permitida.DBE_EMP_ID.toString()
              ) {
                empresa.SELECTED = true;
              }
            });
            _listaEmpresas.push(empresa);
          });

          this.setState({ listaEmpresas: _listaEmpresas });
        }
      }
    } catch (err) {
      alerta('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  encontrarBookBasico = async (bookId) => {
    const { listaBookbasico } = this.state;
    for (let index = 0; index < listaBookbasico.length; index++) {
      const element = listaBookbasico[index];
      if (element.DBB_ID.toString() === bookId.toString()) {
        return element;
      }
    }
  };

  handleChangeBookBasico = async (e) => {
    const book = await this.encontrarBookBasico(e.target.value);
    this.setState({ bookBasicoSelecionado: book });
    if (book !== undefined) {
      await this.carregarListaEmpresasPermitidas(book.DBB_ID);
    } else {
      this.handleLimparEmpresas();
    }
  };

  handleLimparEmpresas = () => {
    let { listaEmpresas } = this.state;
    listaEmpresas.forEach((empresa) => {
      empresa.SELECTED = false;
    });
    this.setState({ listaEmpresas: listaEmpresas });
  };

  handleCheckEmpresa = (e, empresaSelecionada) => {
    var { listaEmpresas } = this.state;

    listaEmpresas.forEach((empresa) => {
      if (empresaSelecionada === empresa) {
        empresa.SELECTED = e.target.checked;
      }
    });
    this.setState({
      listaEmpresas: listaEmpresas,
    });
  };

  preparaListaEmpresa = () => {
    const { listaEmpresas } = this.state;

    listaEmpresas.forEach(async (empresa) => {
      empresa.SELECTED = false;
    });

    this.setState({ listaEmpresas: listaEmpresas });
  };

  handleSalvarPermissao = async () => {
    try {
      const { usuarioAtivo, listaEmpresas, bookBasicoSelecionado } = this.state;
      let permissao = {};

      permissao.DBE_DBB_ID = bookBasicoSelecionado.DBB_ID;
      permissao.DBB_USR_ID = usuarioAtivo;
      permissao.EMPRESAS = [];
      listaEmpresas.forEach(async (empresa) => {
        if (empresa.SELECTED === true) {
          var _empresa = {};
          _empresa.DBB_EMP_ID = empresa.EMP_ID;
          permissao.EMPRESAS.push(_empresa);
        }
      });

      const retorno = await api.put(
        '/v1/permissoes/bookbasico/permitir/' + bookBasicoSelecionado.DBB_ID,
        permissao
      );
      if (!retorno.data.sucess) {
        tratarErros(retorno.data);
      } else {
        this.preparaListaEmpresa();
        this.setState({ bookBasicoSelecionado: {} });
        document.getElementById('bookbasico').value = -1;
      }
    } catch (error) {}
  };

  render() {
    const {
      loading,
      listaBookbasico,
      bookBasicoSelecionado,
      listaEmpresas,
    } = this.state;
    return (
      <>
        <Header />
        <ContainerWindowTitle>
          <DirectTituloJanela
            urlVoltar={'/home'}
            titulo={loading ? 'Carregando...' : 'Book básico - permissões'}
          />
        </ContainerWindowTitle>
        <Container>
          <Linha>
            <DivDetalhe>
              <label for="bookbasico">Book básico</label>
              <select
                style={{ display: 'flex' }}
                id="bookbasico"
                onChange={this.handleChangeBookBasico}
              >
                <option value="-1">
                  {this.state.loading
                    ? 'Aguarde...'
                    : 'Selecione um book básico'}
                </option>
                {listaBookbasico.map((book) => (
                  <option key={book.DBB_ID} value={book.DBB_ID}>
                    {book.DBB_NOME}
                  </option>
                ))}
              </select>
            </DivDetalhe>
          </Linha>
          <Linha>
            <DivDetalhe>
              <label for="descricao"> Descritivo</label>
              <p
                id="descricao"
                style={{
                  border: '1px solid #ccc',
                  minHeight: '100px',
                  height: 'auto',
                  overflowY: 'auto',
                  overflowX: 'none',
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    bookBasicoSelecionado !== undefined &&
                    bookBasicoSelecionado.DBB_DESCRICAO !== undefined &&
                    bookBasicoSelecionado.DBB_DESCRICAO !== null
                      ? bookBasicoSelecionado.DBB_DESCRICAO.toString()
                      : '',
                }}
              ></p>
            </DivDetalhe>
          </Linha>
          <Linha
            style={{
              backgroundColor: 'rgb(247, 247, 247)',
              padding: '10px',
              borderRadius: '10px',
              marginTop: '10px',
              marginRight: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexFlow: 'wrap',
              }}
            >
              {listaEmpresas.map((empresa) => (
                <div style={{ width: '240px' }}>
                  <input
                    type="checkbox"
                    id={empresa.EMP_ID}
                    key={empresa.EMP_ID}
                    value={empresa.EMP_ID}
                    checked={empresa.SELECTED}
                    style={{
                      position: 'relative',
                      opacity: '1',
                      marginRight: '10px',
                      pointerEvents: 'all',
                    }}
                    onClick={(e) => this.handleCheckEmpresa(e, empresa)}
                  />
                  <label
                    for={empresa.EMP_ID}
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {empresa.EMP_NOME.length > 30
                      ? empresa.EMP_NOME.substr(0, 30) + '...'
                      : empresa.EMP_NOME}
                  </label>
                </div>
              ))}
            </div>
          </Linha>
          <LinhaRodape>
            <DivRodape>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  this.handleSalvarPermissao();
                }}
              >
                <Icon>save</Icon> Salvar
              </button>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <Icon>arrow_back</Icon> Cancelar
              </button>
            </DivRodape>
          </LinhaRodape>
        </Container>
      </>
    );
  }
}
